module.exports = __webpack_public_path__ + "static/img/jszh.e8e8e1ab.png";